// Constantes de la pantalla de Vendedores.
import type { SaleCategory } from './lib/sellerDetail';

/** Semanas de la tarjeta de Tendencia; no sigue el periodo de la banda. */
export const TREND_WEEKS = 8;

/** Días de cada semana de la tendencia. */
export const TREND_WEEK_DAYS = 7;

/** Categorías que el mix pinta siempre, en gris si no tuvieron ventas. */
export const MIX_BASE_CATEGORIES: readonly SaleCategory[] = [
    'ACCESSORY',
    'PHONE',
    'SERVICE',
    'SIM',
];
